import {
  type ComponentProps,
  type LayoutData,
  Region,
} from "@enonic/react-components";

export const ThreeColumnLayout = ({
  component,
  meta,
  data,
}: ComponentProps<LayoutData>) => {
  const margin = typeof data?.margin === "string" ? data.margin : "";
  return (
    <div data-portal-component-type="layout">
      <div className={`three-column-layout ${margin}`}>
        <Region
          data={component.regions.left.components}
          meta={meta}
          name="left"
        />
        <Region
          data={component.regions.middle.components}
          meta={meta}
          name="middle"
        />
        <Region
          data={component.regions.right.components}
          meta={meta}
          name="right"
        />
      </div>
    </div>
  );
};
